var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.$moment2text(_vm.$text2moment(_vm.value), 'DD/MM/YYYY HH:mm:ss')))])}
var staticRenderFns = []

export { render, staticRenderFns }